module.exports = __webpack_public_path__ + "assets/img/main-logo-baoding.71b9a0d0.png";